export const USER_ROLES = {
    CLIENT: 'CLIENT',
    PROVIDER: 'PROVIDER',
  };
  